import z from "zod";

const groupDataSchema = z.object({
    ip: z.string().nullable(),
    name: z.string().nullable(),
});

export { groupDataSchema };
